export function dateFormatterUTC(value) {
    if (!value) return ''

    let temp = new Date(value)

    if (isNaN(temp)) return 'Invalid Date'

    let month = ("00" + (temp.getUTCMonth() + 1)).slice(-2)
    let date = ("00" + temp.getUTCDate()).slice(-2)
    let year = ("0000" + temp.getUTCFullYear()).slice(-4)

    return `${month}/${date}/${year}`
}

export function dateLongFormatterUTC(value) {
    if (!value) return ''

    let temp = new Date(value)

    if (isNaN(temp)) return 'Invalid Date'

    let month = ("00" + (temp.getUTCMonth() + 1)).slice(-2)
    let date = ("00" + temp.getUTCDate()).slice(-2)
    let year = ("0000" + temp.getUTCFullYear()).slice(-4)

    let numberHours = (temp.getUTCHours())
    let period = 'AM'

    if (numberHours > 12) {
        numberHours -= 12
        period = 'PM'
    }

    let hours = ("00" + numberHours).slice(-2)
    let minutes = ("00" + temp.getUTCMinutes()).slice(-2)
    let seconds = ("00" + temp.getUTCSeconds()).slice(-2)

    return `${month}/${date}/${year} @ ${hours}:${minutes}:${seconds} ${period}`
}

export function formatDecimal(number, digits) {
    let num = 0

    return number ? number.toFixed(digits) : num.toFixed(digits)
}

export function formatFileSize(bytes, decimalPoint) {
    if (bytes === 0) return '0 Bytes'

    let k = 1000
    let dm = decimalPoint || 2
    let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    let i = Math.floor(Math.log(bytes) / Math.log(k))

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}